import { NavLink, Outlet } from 'react-router';
import { useAuth } from '../auth/AuthProvider';
import { shopName, useEmulators } from '../config';
import { AnalyticsConsentBanner, PageTracker } from './AnalyticsConsent';

export function Layout() {
  const { state, signOutUser } = useAuth();
  const user = state.status === 'signedIn' ? state.user : null;
  const role = state.status === 'signedIn' ? state.role : null;

  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar__inner">
          <span className="topbar__brand">{shopName}</span>
          {role && (
            <nav className="topbar__nav" aria-label="Main">
              <NavLink to="/clients">Clients</NavLink>
              <NavLink to="/renewals">Renewals</NavLink>
              {role === 'admin' && <NavLink to="/staff">Staff</NavLink>}
              <NavLink to="/account">Account</NavLink>
            </nav>
          )}
          {user && (
            <div className="topbar__user">
              <span className="topbar__email" title={role ?? 'no role'}>
                {user.email}
                {role === 'admin' && <span className="tag">admin</span>}
              </span>
              <button type="button" className="btn btn--ghost" onClick={() => void signOutUser()}>
                Sign out
              </button>
            </div>
          )}
        </div>
        {useEmulators && <div className="emulator-banner">Local emulators — not real data</div>}
      </header>
      <main className="content">
        <Outlet />
      </main>
      <PageTracker />
      <AnalyticsConsentBanner />
    </div>
  );
}
